import { render } from "./logros.vue?vue&type=template&id=2d0e0189&scoped=true"
import script from "./logros.vue?vue&type=script&lang=js"
export * from "./logros.vue?vue&type=script&lang=js"

import "./logros.vue?vue&type=style&index=0&id=2d0e0189&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0e0189"]])

export default __exports__